export const companyFields = {
  name: { type: 'string', description: 'Company name (required).' },
  display_name: { type: 'string', description: 'Optional display name shown in the UI.' },
  address_street: { type: 'string', description: 'Street address.' },
  address_city: { type: 'string', description: 'City.' },
  address_zip: { type: 'string', description: 'ZIP / postal code.' },
  address_country_iso: { type: 'string', description: 'Country ISO code, e.g. "CH" or "DE".' },
  homepage: { type: 'string', description: 'Company website URL.' },
  parent_company_id: {
    type: ['number', 'null'],
    description: 'Parent company ID for the hierarchy. Null for a root company.',
  },
  brand_colors: {
    type: 'array',
    description:
      'Brand colours used on the ads built for this company. Setting it replaces the whole list; an empty array clears the colours.',
    items: {
      type: 'object',
      properties: {
        value: {
          type: 'string',
          description: 'An rgba string such as "rgba(0, 113, 93, 1)"; r, g and b are 0-255 and a is 0-1.',
        },
        role: { type: 'string', enum: ['primary', 'accent'], description: 'Which brand colour this is.' },
      },
      required: ['value'],
    },
  },
};
